import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'auction>saved_remove_all'
	},

	validation: {},

	gql: {
		schema: gql`
			mutation AuctionSavedRemoveAll(
				$real_estate_id: ID
			) {
				request(
					real_estate_id: $real_estate_id
				) {
					response
				}
			}
		`
	}
};

export default request;
